import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class OfflineTip extends Component {
    state = {
        open: false,
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleOfflineClick = () => {
        this.setState({ open: !this.state.open });
    }

    render() {
        return (
            <div style={this.props.style} onClick={this.handleOfflineClick}>
                {this.props.children}
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {'You Are Offline'}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {'It looks like you have lost your internet connection. You can still use this platform but the following functionalities will be disabled.'}
                        </DialogContentText>
                        <ul>
                            <li>Share contents and files</li>
                            <li>Deep Search</li>
                            <li>Do / undo favorites</li>
                            <li>Edit content</li>
                            <li>Change Password</li>
                            <li>Receive new notifications</li>
                        </ul>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary" autoFocus>
                            {'Ok'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
OfflineTip.propTypes = {
    children: PropTypes.any.isRequired,
    style: PropTypes.object.isRequired,
};

export default OfflineTip;